<script>
const Alert = require('../../services/alert.js');

export default {
  props: {
    user: {},
    activeUsers: {
      default: () => ([]),
    },
    private: false,
  },

  data () {
    return {
      query: '',
      show: false,
      loading: true,
      actives: this.activeUsers,
      allUsers: this.users,
    };
  },

  store: ['users'],

  watch: {
    users (users) {
      if (users) {
        this.allUsers = users;
        this.loading = false;
      }
    },
  },

  mounted () {
    Bus.$on('closeUsersModal', () => this.show = false);
    Bus.$on('usersSearch', (query) => this.query = query);
    this.loading = !!this.users;
    if (this.users == '') {
      this.loading = false;
    }
  },

  computed: {
    title () {
      const str = (this.actives.length > 1 && this.can) ? this.__('Donos') : this.__('Dono');

      return str + this.__(' do Lead');
    },

    /*
       * Some computed helpers to make my life easier.
       */
    hasMinUsers () {
      return this.users.length > 1;
    },

    hasActives () {
      return this.publicUsers.length != 0;
    },

    can () {
      return ! this.private || this.user.admin;
    },

    showModal () {
      return this.show && ! this.loading && this.can;
    },

    firstPublicUser () {
      return this.hasActives ? this.publicUsers[0] : [];
    },

    publicUsers () {
      if (this.can) {
        return this.actives;
      }

      return this.actives.filter((user) => user.id == this.user.id);
    },

    usersByName () {
      return this.users.filter((user) => user.name.toLowerCase().startsWith(this.query.toLowerCase()));
    },
  },

  methods: {
    toggleActive (id) {
      const user = this.actives.find((user) => user.id == id);

      return user ? this.removeUser(user) : this.addUser(id);
    },

    removeUser (user, prevent = false) {
      this.actives.splice(this.actives.indexOf(user), 1);

      return new Promise((resolve, reject) => {
        if (this.store && ! prevent) {
          this.store(user.id)
            .then(() => resolve(this.actives))
            .catch(() => {
              this.addUser(user.id, true);

              Alert.error(this.errors.removeUser);
            });
        } else {
          resolve(this.actives);
        }
      });
    },

    addUser (id, prevent = false) {
      const user = this.users.find((user) => user.id == id);

      this.actives.push(user);

      return new Promise((resolve, reject) => {
        if (this.store && ! prevent) {
          this.store(user.id)
            .then(() => resolve(this.actives))
            .catch(() => {
              this.removeUser(user, true);
              Alert.error(this.errors.addUser);
            });
        } else {
          resolve(this.actives);
        }
      });
    },

    toggleModal (force = false) {
      if (! this.show) {
        Bus.$emit('closeUsersModal');

        this.$nextTick(() => {
          this.show = force ? ! force : ! this.show;
        });
      } else {
        this.show = false;
      }
    },

    isActive (id) {
      return !! this.actives.find((user) => user.id == id);
    },
  },
};
</script>
